import { Component, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { ArticleMappingService } from '../../../services/ArticleMappingService';

interface ArticleProperty {
  name: string;
  type: string;
  description: string;
}

@Component({
  selector: 'app-article-properties',
  templateUrl: './article-properties.component.html',
  styleUrls: ['./article-properties.component.scss']
})
export class ArticlePropertiesComponent implements OnInit {
  properties: ArticleProperty[] = [];
  displayedColumns: string[] = ['name', 'type', 'description'];

  constructor(private mappingService: ArticleMappingService) {}

  ngOnInit() {
    this.mappingService.getMappings().subscribe({
      next: (data) => {
        // Transform the properties into our desired format
        this.properties = Object.entries(data.mappings.properties)
          .map(([key, value]: [string, any]) => ({
            name: key,
            type: value.type,
            description: value.fields ? 'Has additional fields' : value.type
          }));
        //console.log('Article properties:', this.properties);
      },
      error: (error) => {
        console.error('Failed to load article properties:', error);
      }
    });
  }
}